export default [
  {
    path: '',
    name: 'promo list',
    component: () => import('@/views/app/promo/list/page-list.vue'),
    meta: { title: 'Daftar Promo' },
  },
  {
    path: 'baru',
    name: 'promo create',
    component: () => import('@/views/app/promo/create/page-create.vue'),
    meta: { title: 'Tambah Promo' },
  },
  {
    path: 'edit/:id',
    name: 'promo edit',
    component: () => import('@/views/app/promo/edit/page-edit.vue'),
    meta: { title: 'Ubah Informasi Promo' },
  },
  {
    path: ':id',
    name: 'promo detail',
    component: () => import('@/views/app/promo/detail/page-detail.vue'),
    meta: { title: 'Detail Informasi Promo' },
  },
]
